import { Grid, Stack, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../../constants/FieldsConst';
import { textLabels } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import * as ROUTES from '../../../../../router/Routes';
import { LoadingWidget } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { allCarrerasAction } from '../../../../sistema/carreras/CarrerasAction';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntHorarioClasesAction,
  deleteEntHorarioClasesAction,
  oneEntHorarioClasesAction,
  setActivoEntHorarioClasesAction,
} from '../EntHorarioClasesAction';
import { PARAMS_ENT_HORARIO_CLASES } from '../EntHorarioClasesReducer';

const ListadoEntHorarioClases = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const carrerasStore = Redux.useSelector((state) => state.carreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (carrerasStore.all && carrerasStore.all.length === 0) {
        await allCarrerasAction(dispatch, null);
      }

      const payload = {
        ...entHorariosClasesStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_ENT_HORARIO_CLASES, payload });
      if (
        entHorariosClasesStore.all &&
        entHorariosClasesStore.all.length === 0
      ) {
        await allEntHorarioClasesAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = entHorariosClasesStore.all.find((el) => el.id === id);
    await setActivoEntHorarioClasesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntHorarioClasesAction(
      { dispatch, notify },
      entHorariosClasesStore.activo.id,
      entHorariosClasesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const _onPanel = async (id) => {
    const res = await oneEntHorarioClasesAction(dispatch, id);
    if (res.dias.length === 0 || res.bloques.length === 0) {
      notify(
        'No se han definido los días o bloques para este horario de clases',
        { warning: true },
      );
      setTimeout(() => {
        notify('Redirigiendo a la configuración del horario...');
        setTimeout(() => {
          history.push(ROUTES.entHorarioClasesAjustes.to);
        }, 500);
      }, 1000);
    } else {
      history.push(ROUTES.panelHorarios.to);
    }
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent onClick={() => _onPanel(tableMeta.rowData[0])}>
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.start.name,
      label: CONST.start.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.end.name,
      label: CONST.end.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.totalBloques.name,
      label: CONST.totalBloques.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.totalDias.name,
      label: CONST.totalDias.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.desc.name,
      label: CONST.desc.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.estatus.name,
    //   label: CONST.estatus.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Tooltip
    //           describeChild
    //           title="Estatus del registro"
    //           placement="left"
    //         >
    //           <Chip
    //             label={value.nombre}
    //             size="small"
    //             color={value.id === 1 ? 'success' : 'error'}
    //           />
    //         </Tooltip>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" sx={{ width: '80px' }}>
              <BotonComponent
                click={() => _onPanel(tableMeta.rowData[0])}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel del torneo"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onAjustes={async () => {
                  await oneEntHorarioClasesAction(
                    dispatch,
                    tableMeta.rowData[0],
                  );
                  history.push(ROUTES.entHorarioClasesAjustes.to);
                }}
                onDelete={async () => {
                  const data = entHorariosClasesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntHorarioClasesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    // onRowClick: (rowData, rowMeta) => {
    //   _handleEditClick(rowData[0])
    // },
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={entHorariosClasesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={entHorariosClasesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entHorariosClasesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          {entHorariosClasesStore.activo.nombre}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntHorarioClases;
